import React from "react";
import { Grid, Box } from "@mui/material";
import StoreIcon from "@mui/icons-material/Store";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import { HashLink } from "react-router-hash-link";
import { useTranslation } from "react-i18next";
import PublicIcon from "@mui/icons-material/Public";

const AdminLeftMenu = ({}) => {
  const { t, i18n } = useTranslation();
  return (
    <Grid
      item
      md={2.5}
      sm={12}
      sx={{ borderRight: "1px solid #f0f0ee", minHeight: "400px" }}
    >
      <Box sx={{ px: 8, py: 4 }}>
        <Box sx={{ fontSize: "15px", pb: 2 }}>
          <StoreIcon
            sx={{
              position: "relative",
              top: "+3px",
              fontSize: "18px",
              pr: 2,
            }}
          />
          {t("Shop Manager")}
        </Box>
        {/* <Box>
          <HashLink to="">
            <SearchIcon
              sx={{
                position: "relative",
                top: "+3px",color:"gray",
                fontSize: "18px",
                pr: 2,
                pt: 1,
              }}
            />
            Search
          </HashLink>
        </Box> */}
        <Box>
          <HashLink to="/admin/dashboard">
            <HomeOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("admin_Dashboard")}
          </HashLink>
        </Box>
        <Box>
          <HashLink to="/admin/admins">
            <AdminPanelSettingsOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Admins")}
          </HashLink>
        </Box>
        <Box sx={{ pt: "10px" }}>
          <PublicIcon
            sx={{ fontSize: "15px", position: "relative", top: "+3px", pr: 1 }}
          />{" "}
          한국
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/orders_ko">
            <ShoppingCartOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Orders - Korea")}
          </HashLink>
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/products_ko">
            <Inventory2OutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Products_admin")}
          </HashLink>
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/users_ko">
            <GroupOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Users")} - 한국
          </HashLink>
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/board">
            <AssessmentOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                fontSize: "18px",
                color: "gray",
                pr: 1,
                pt: 1,
              }}
            />
            공지사항 게시판 관리
          </HashLink>
        </Box>
        <Box sx={{ pt: "10px" }}>
          <PublicIcon
            sx={{ fontSize: "15px", position: "relative", top: "+3px", pr: 1 }}
          />{" "}
          미국
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/orders_us">
            <ShoppingCartOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Orders - USA")}
          </HashLink>
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/products_us">
            <Inventory2OutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Products_admin")}
          </HashLink>
        </Box>
        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/users_us">
            <GroupOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Users")} - USA
          </HashLink>
        </Box>

        <Box sx={{ pl: 2 }}>
          <HashLink to="/admin/finance">
            <CreditCardOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Finances")}
          </HashLink>
        </Box>

        {/* <Box>
          <HashLink to="/admin/sent-emails">
            <MarkEmailReadOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 2,
                pt: 1,
              }}
            />
            {t("Sent Emails")}
          </HashLink>
        </Box> */}
        <Box>
          <HashLink to="/admin/stat">
            <AssessmentOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                color: "gray",
                fontSize: "18px",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Statstics - Users")}
          </HashLink>
        </Box>
        <Box>
          <HashLink to="/admin/stat2">
            <AssessmentOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                fontSize: "18px",
                color: "gray",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Statstics - Website")}
          </HashLink>
        </Box>
        <Box>
          <HashLink to="/admin/stat3">
            <AssessmentOutlinedIcon
              sx={{
                position: "relative",
                top: "+3px",
                fontSize: "18px",
                color: "gray",
                pr: 1,
                pt: 1,
              }}
            />
            {t("Statstics - Regions")}
          </HashLink>
        </Box>
      </Box>
    </Grid>
  );
};

export default AdminLeftMenu;
